"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useLabels } from "@/lib/labels/LabelsProvider";
import type { LocaleCode } from "@/lib/labels/types";
interface ArticlePublishedInfoProps {
  publishedAt: string | null | undefined;
  updatedAt: string | null | undefined;
  locale: LocaleCode;
  className?: string;
}
const UPDATED_THRESHOLD_MS = 60_000;
function formatDateTime(value: string, locale: LocaleCode): string {
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(new Date(value));
}
function formatTime(value: string, locale: LocaleCode): string {
  return new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(new Date(value));
}
export function ArticlePublishedInfo(t0) {
  const $ = _c(19);
  const {
    publishedAt,
    updatedAt,
    locale,
    className
  } = t0;
  const labels = useLabels();
  if (!publishedAt) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] !== publishedAt || $[1] !== updatedAt) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const publishedDate = new Date(publishedAt);
      if (Number.isNaN(publishedDate.getTime())) {
        t2 = null;
        break bb0;
      }
      const updatedDate = updatedAt ? new Date(updatedAt) : null;
      t1 = updatedDate && !Number.isNaN(updatedDate.getTime()) && updatedDate.getTime() - publishedDate.getTime() > UPDATED_THRESHOLD_MS;
    }
    $[0] = publishedAt;
    $[1] = updatedAt;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const hasUpdate = t1;
  let t3;
  if ($[4] !== locale || $[5] !== publishedAt) {
    t3 = formatDateTime(publishedAt, locale);
    $[4] = locale;
    $[5] = publishedAt;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== publishedAt || $[8] !== t3) {
    t4 = <time dateTime={publishedAt}>{t3}</time>;
    $[7] = publishedAt;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hasUpdate || $[11] !== labels || $[12] !== locale || $[13] !== updatedAt) {
    t5 = hasUpdate && updatedAt && <>{" ("}{labels.articlePage.updatedOn}: <time dateTime={updatedAt}>{formatTime(updatedAt, locale)}</time>{")"}</>;
    $[10] = hasUpdate;
    $[11] = labels;
    $[12] = locale;
    $[13] = updatedAt;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== className || $[16] !== t4 || $[17] !== t5) {
    t6 = <span className={className}>{t4}{t5}</span>;
    $[15] = className;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}